import { render } from "./UserManage.vue?vue&type=template&id=71f879fa&scoped=true"
import script from "./UserManage.vue?vue&type=script&lang=js"
export * from "./UserManage.vue?vue&type=script&lang=js"

import "./UserManage.vue?vue&type=style&index=0&id=71f879fa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71f879fa"]])

export default __exports__